var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.337,
    height: 17.246,
    viewBox: "0 0 16.337 17.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-thumbs-up",
    "data-name": "Icon ionic-ios-thumbs-up",
    d: "M14.347,13.1A1.555,1.555,0,0,0,15,11.893a1.673,1.673,0,0,0-.426-1.119c-.023-.046-.043-.088-.063-.131L14.5,10.6a.5.5,0,0,1,.078-.385,1.664,1.664,0,0,0,.227-.988,1.16,1.16,0,0,0-.379-.892.724.724,0,0,1-.16-.7,1.465,1.465,0,0,0-.32-1.453c-.41-.454-.793-.508-1.813-.45-.7.042-2.169.265-3.134.415-.395.062-.739.115-.844.123-.5.05-.594,0-.641-.188a1.234,1.234,0,0,1,.192-.5A8.172,8.172,0,0,0,8.274,4.2,4.758,4.758,0,0,0,8.168.734,1.276,1.276,0,0,0,7.14,0,1.572,1.572,0,0,0,6.05.3c-.133.154-.09.446-.242,1.031a11.073,11.073,0,0,1-.469,1.615A11.127,11.127,0,0,1,3.111,5.272c-.16.138-.3.258-.395.35a7.945,7.945,0,0,0-1,1.257,6.7,6.7,0,0,1-.535.711,1.422,1.422,0,0,1-.872.419A.311.311,0,0,0,0,8.317V14.45a.321.321,0,0,0,.324.319,6.247,6.247,0,0,1,2.6.454,6.842,6.842,0,0,0,1.813.465,38.145,38.145,0,0,0,4.4.311,19.792,19.792,0,0,0,2.212-.15c1.212-.138,2.509-.415,2.939-1.423a1.07,1.07,0,0,0-.02-.911.3.3,0,0,1-.031-.1A.323.323,0,0,1,14.347,13.1Z",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 0, 1.307)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumbUp.8ba03b34c6f788311eed719270bf46e7.svg";
export { ForwardRef as ReactComponent };